import { render, staticRenderFns } from "./CustomerPhotosDisplay.vue?vue&type=template&id=2073c9f3&scoped=true&"
import script from "./CustomerPhotosDisplay.vue?vue&type=script&lang=js&"
export * from "./CustomerPhotosDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPhotosDisplay.vue?vue&type=style&index=0&id=2073c9f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073c9f3",
  null
  
)

export default component.exports